import validator from "validator";

export default function validation(data, rules) {
  let errors = {};
  Object.keys(data).forEach((field) => {
    if (rules.hasOwnProperty(field)) {
      //If requested rules are for array of json
      if (rules[field].isArrayJson) {
        if (rules[field].required && data[field].length === 0) {
          return (errors = { ...errors, [field]: ["Value required"] });
        }
        //Loop through each json and set their rules.
        data[field].map((ele) => {
          //Rules for this this particular ele.
          let localRules = {};

          Object.keys(rules[field]).forEach((key) => {
            //Make rules for every key in rules except isArray & separator.
            if (
              ![
                "isArrayJson",
                "separator",
                "dynamicRules",
                "hasDynamicRules",
              ].includes(key)
            ) {
              let currentKey = key + "_" + ele[rules[field].separator];
              if (
                rules[field].hasDynamicRules &&
                currentKey in rules[field]["dynamicRules"]
              ) {
                localRules[currentKey] = {
                  ...rules[field]["dynamicRules"][currentKey],
                };
              }
              localRules[currentKey] = {
                ...localRules[currentKey],
                ...rules[field][key],
              };
            }
          });
          //Using recursion, this will return error for this particular element.
          let localError = validation(ele, localRules);
          //concatenate the current element errors with main errors.
          errors = { ...errors, ...localError };
        });
      }
      let fielderrors = [];
      let val =
        typeof data[field] === "string" || data[field] === null
          ? data[field]
          : JSON.stringify(data[field]);
      if (val !== null && val !== undefined) {
        if (
          rules[field].required &&
          (validator.isEmpty(val) || val === "{}" || val === "[]")
        ) {
          fielderrors.push(`Value required`);
        }
        if (!validator.isEmpty(val)) {
          if (
            rules[field].isMobile &&
            parseInt(val).toString().length !== rules[field].exactlength
          ) {
            fielderrors.push(`Enter valid mobile number`);
          }
          if (
            rules[field].minLength &&
            typeof val !== "number" &&
            val.length < rules[field].minLength
          ) {
            fielderrors.push(
              `Enter at least ${rules[field].minLength}` + " characters",
            );
          }
          if (
            rules[field].maxLength &&
            typeof val !== "number" &&
            val.length > rules[field].maxLength
          ) {
            fielderrors.push(
              `Enter at most ${rules[field].maxLength}` + " characters",
            );
          }
          if (
            rules[field].exactLength &&
            typeof val !== "number" &&
            val.length != rules[field].exactLength
          ) {
            fielderrors.push(
              `Characters must be ${rules[field].exactLength}` + " in length",
            );
          }
          if (rules[field].number && !validator.isNumeric(val)) {
            fielderrors.push("Enter only numbers");
          }
          if (
            rules[field].number &&
            validator.isNumeric(val) &&
            rules[field].minVal !== undefined &&
            parseInt(val) < rules[field].minVal
          ) {
            fielderrors.push(
              rules[field].errorMessage ||
                `Enter number greater than or equal to ${rules[field].minVal}`,
            );
          }
          if (
            rules[field].number &&
            validator.isNumeric(val) &&
            rules[field].maxVal !== undefined &&
            parseInt(val) > rules[field].maxVal
          ) {
            fielderrors.push(
              rules[field].errorMessage ||
                `Enter number smaller than or equal to ${rules[field].maxVal}`,
            );
          }
          if (rules[field].alpha && !validator.isAlpha(val)) {
            fielderrors.push("Enter only letters");
          }
          if (rules[field].email && !validator.isEmail(val)) {
            fielderrors.push("Enter a valid email address");
          }
          if (
            rules[field].pattern &&
            !validator.matches(val, rules[field].pattern)
          ) {
            fielderrors.push("Invalid File");
          }
          if (rules[field].url && !validator.isURL(val)) {
            fielderrors.push("Enter a valid url");
          }
          //For decimal numbers validation
          if (
            rules[field].decimalNumber &&
            rules[field].startDecimalVal !== undefined &&
            parseFloat(val) <= rules[field].startDecimalVal
          ) {
            fielderrors.push(
              rules[field].errorMessage ||
                `Enter number greater than ${rules[field].startDecimalVal}`,
            );
          }
          if (
            rules[field].decimalNumber &&
            rules[field].endDecimalVal !== undefined &&
            parseFloat(val) >= rules[field].endDecimalVal
          ) {
            fielderrors.push(
              rules[field].errorMessage ||
                `Enter number less than ${rules[field].endDecimalVal}`,
            );
          }
        }
        // Date pair validation - required_with
        if (rules[field].required_with) {
          const relatedField = rules[field].required_with;
          const relatedValue = data[relatedField];

          if (
            relatedValue &&
            relatedValue !== null &&
            !validator.isEmpty(String(relatedValue))
          ) {
            if (!val || val === null || validator.isEmpty(val)) {
              fielderrors.push(
                `This field is required when ${relatedField} is provided`,
              );
            }
          }
        }
        // Date comparison validation - after
        if (rules[field].after) {
          if (val && !validator.isEmpty(val)) {
            const compareField = rules[field].after;
            const compareValue = data[compareField];

            if (compareValue && !validator.isEmpty(String(compareValue))) {
              const currentDate = new Date(val);
              const compareDate = new Date(compareValue);

              if (currentDate <= compareDate) {
                fielderrors.push(`End date must be after start date`);
              }
            }
          }
        }
      } else if (val === null && rules[field].required) {
        fielderrors.push(`Value required`);
      }
      if (fielderrors.length > 0) {
        errors[field] = fielderrors;
      }
    }
  });
  return errors;
}

export function validateScheduleData(scheduleData, options = {}) {
  const { type = "slots", required = true, fieldName = "Schedule" } = options;

  const errors = [];
  const validDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  // Check if scheduleData exists
  if (!scheduleData || typeof scheduleData !== "object") {
    if (required) {
      return {
        isValid: false,
        errors: [`${fieldName} data is required`],
      };
    }
    return { isValid: true, errors: [] };
  }

  // Check if at least one day is configured
  const configuredDays = Object.keys(scheduleData).filter((day) =>
    validDays.includes(day),
  );

  if (configuredDays.length === 0 && required) {
    return {
      isValid: false,
      errors: [`At least one day must be configured for ${fieldName}`],
    };
  }

  // Validate based on type
  if (type === "slots") {
    // Validate refill schedule (array of time slots)
    validateTimeSlots(scheduleData, validDays, errors, fieldName);
  } else if (type === "range") {
    // Validate machine uptime (time range with enabled flag)
    validateTimeRanges(scheduleData, validDays, errors, fieldName);
  }

  return {
    isValid: errors.length === 0,
    errors: errors,
  };
}

function validateTimeSlots(scheduleData, validDays, errors, fieldName) {
  // Check if at least one day has time slots
  const daysWithSlots = Object.keys(scheduleData).filter(
    (day) =>
      validDays.includes(day) &&
      Array.isArray(scheduleData[day]) &&
      scheduleData[day].length > 0,
  );

  if (daysWithSlots.length === 0) {
    errors.push(`At least one day must have time slots configured`);
    return;
  }

  validDays.forEach((day) => {
    if (scheduleData[day]) {
      // Check if it's an array
      if (!Array.isArray(scheduleData[day])) {
        errors.push(`${day}: Time slots must be an array`);
        return;
      }

      // If array is empty, skip validation (optional schedule for this day)
      if (scheduleData[day].length === 0) {
        return;
      }

      // Validate each time slot
      scheduleData[day].forEach((slot, index) => {
        // Check if slot is an object
        if (!slot || typeof slot !== "object") {
          errors.push(`${day} - Slot ${index + 1}: Invalid time slot format`);
          return;
        }

        // Check for hh and mm properties
        if (!("hh" in slot) || !("mm" in slot)) {
          errors.push(
            `${day} - Slot ${index + 1}: Missing hour (hh) or minute (mm) field`,
          );
          return;
        }

        // Validate hour (hh)
        const hour = parseInt(slot.hh, 10);
        if (isNaN(hour) || hour < 0 || hour > 23) {
          errors.push(
            `${day} - Slot ${index + 1}: Hour must be between 00 and 23`,
          );
        }

        // Validate minute (mm)
        const minute = parseInt(slot.mm, 10);
        if (isNaN(minute) || minute < 0 || minute > 59) {
          errors.push(
            `${day} - Slot ${index + 1}: Minute must be between 00 and 59`,
          );
        }

        // Validate format (should be 2 digits)
        if (!/^\d{2}$/.test(slot.hh)) {
          errors.push(
            `${day} - Slot ${index + 1}: Hour must be in 2-digit format (e.g., 09, not 9)`,
          );
        }
        if (!/^\d{2}$/.test(slot.mm)) {
          errors.push(
            `${day} - Slot ${index + 1}: Minute must be in 2-digit format (e.g., 05, not 5)`,
          );
        }
      });

      // Check for duplicate time slots on the same day
      const timeStrings = scheduleData[day].map(
        (slot) => `${slot.hh}:${slot.mm}`,
      );
      const uniqueTimes = new Set(timeStrings);
      if (timeStrings.length !== uniqueTimes.size) {
        errors.push(`${day}: Contains duplicate time slots`);
      }
    }
  });
}

function validateTimeRanges(scheduleData, validDays, errors, fieldName) {
  validDays.forEach((day) => {
    if (scheduleData[day]) {
      const dayData = scheduleData[day];

      // Check if it's an object
      if (typeof dayData !== "object" || Array.isArray(dayData)) {
        errors.push(`${day}: Invalid data format`);
        return;
      }

      // Check required fields
      if (!("enabled" in dayData)) {
        errors.push(`${day}: Missing 'enabled' field`);
      } else if (typeof dayData.enabled !== "boolean") {
        errors.push(`${day}: 'enabled' must be a boolean value`);
      }

      // If enabled, validate time fields
      if (dayData.enabled) {
        if (!("startTime" in dayData) || !("endTime" in dayData)) {
          errors.push(`${day}: Missing 'startTime' or 'endTime' field`);
          return;
        }

        // Validate time format (HH:MM)
        const timeRegex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;

        if (!timeRegex.test(dayData.startTime)) {
          errors.push(
            `${day}: Invalid 'startTime' format. Expected HH:MM (e.g., 09:30)`,
          );
        }

        if (!timeRegex.test(dayData.endTime)) {
          errors.push(
            `${day}: Invalid 'endTime' format. Expected HH:MM (e.g., 18:30)`,
          );
        }

        // Validate that endTime is after startTime (must be same day)
        if (
          timeRegex.test(dayData.startTime) &&
          timeRegex.test(dayData.endTime)
        ) {
          const [startHour, startMin] = dayData.startTime
            .split(":")
            .map(Number);
          const [endHour, endMin] = dayData.endTime.split(":").map(Number);

          const startMinutes = startHour * 60 + startMin;
          const endMinutes = endHour * 60 + endMin;

          if (endMinutes <= startMinutes) {
            errors.push(
              `${day}: End time must be after start time within the same day`,
            );
          }
        }
      }
    }
  });
}

export function formatScheduleErrors(errors) {
  return errors.map((error, index) => `${index + 1}. ${error}`);
}
